import React from 'react'
import PPVTemplate from 'src/components/page/ppv'

export default (props) => {
  return (
    <PPVTemplate
      location={props.location}
      lang="en"
      market="us"
      title="Stream & DVR live sports"
      subtitle="Catch your games on your TV, phone, tablet & more."
      networkSet="sports"
    />
  )
}
